import React from 'react';

import { ReactComponent as EletricShockSvg } from './assets/electric-shock.svg';

type Name = 'electric-shock';
type Props = {
  name: Name;
};

const Illustration: React.FC<Props> = ({ name }) => {
  if (name === 'electric-shock') {
    return <EletricShockSvg data-testid="illustration" />;
  }

  return null;
};

export default Illustration;
